<template>
  <div class="bigSlide">
    <el-carousel :height="height + 'px'">
      <el-carousel-item v-for="(item, idx) in BannerList" :key="idx">
        <el-image fit="cover" class="bigImg" :src="item.PicUrl">
          <div slot="placeholder" class="image-slot"></div>
        </el-image>
        <div class="bigTxt" :class="{bannerEn:lang == 'en'}">
          <h3 v-html="changeValue(item.Title)"></h3>
          <!-- <h4>{{ item.name2 }}</h4> -->
          <p class="enName" v-html="item.SubTitle "></p>
          <div class="bigBtnBox">
            <a :href="item.Link"
              ><span class="bigMore">{{lang=="en"?'Learn More':'了解更多'}}</span></a
            >
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { changeText } from "@/utils/tool";

export default {
  data() {
    return {
      list: [
        {
          url: "images/title01.jpg",
          name: "让世界感受碳纤维力量",
          name2: "",
          enName: "LET THE WORLD FEEL THE POWER OF CARBON FIBER",
        },
        {
          url: "images/title02.jpg",
          name2: "央企十大超级工程",
          name: "西宁万吨碳纤维项目入选",
          enName: "",
        },
        {
          url: "images/title03.jpg",
          name2: "国家科技进步一等奖",
          name: "中复神鹰碳纤维项目荣获",
          enName: "",
        },
      ],
      // list:BannerList
    };
  },
  methods: {
    changeValue(value) {
      return changeText(value);
    },
  },
  props: ["height", "BannerList","lang"],
};
</script>

<style lang="scss">
.bigSlide {
  position: relative;
  color: #fff;
  .bigImg {
    height: 100%;
    width: 100%;
  }
  .bigTxt {
    position: absolute;
    left:0;
    right:0;
    top:0;
    bottom:0;
    display: flex;
    justify-content: center;
    flex-direction:column;
    width: 1280px;
    margin:auto;
    .enName {
      font-size: 26px;
      font-weight: 300;
      color: #fff;
    }
    h3,
    h4 {
      font-size: 62px;
      font-weight: 600;
      color: #fff;
    }
    .bigBtnBox {
      padding: 30px 0 0 0;
      a{display: block;line-height: 50px;}
    }
  }
  .is-active {
    .el-carousel__button {
      background: #d71820;
    }
  }
  .bannerEn{
    h3{font-size: 48px;}
}
}

/* .el-image__placeholder {
  background: url("~@/assets/images/loading.gif") no-repeat 50% 50%;
  background-size: 50%;
  width: 50vw;
  height: 200px;
} */
</style>